import { AxiosResponse } from 'axios';
import useAxiosMutation from 'hooks/useAxiosMutation';
import { useQueryClient } from 'react-query';
import { BLUEPRINT_SHARED_TOKEN_CACHE_KEY } from 'services/queryKeys';
import { ShareBlueprintRequest, SharedBlueprintToken } from 'types';

type ShareBlueprintParams = {
  blueprintId: number;
  tsExpiration: string;
};

export const useShareBlueprint = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, mutate, isLoading, isError, error } = useAxiosMutation();

  const shareBlueprint = async ({
    blueprintId,
    tsExpiration,
  }: ShareBlueprintParams): Promise<{ data: SharedBlueprintToken }> => {
    const requestBody: ShareBlueprintRequest = {
      ts_expiration: tsExpiration,
    };

    const result = await mutateAsync({
      method: 'POST',
      path: `/blueprints/${blueprintId}/share/`,
      body: requestBody,
    });

    // Invalidate the shared token cache after successful mutation
    queryClient.invalidateQueries(BLUEPRINT_SHARED_TOKEN_CACHE_KEY(blueprintId));

    // Data is already transformed by useAxiosMutation (snake_case to camelCase)
    const axiosResult = result as AxiosResponse;
    return { data: axiosResult.data as SharedBlueprintToken };
  };

  return {
    shareBlueprint,
    mutate,
    isLoading,
    isError,
    error,
  };
};
